import { NavigationItem } from "@/modules/common/features/navigation/model/types";
import { FileTextOutlined } from "@ant-design/icons";
import { COMPANY_DOCUMENTS_PATH } from "@/modules/documents/pages/company-documents";

export const documentsMenu: NavigationItem[] = [
  {
    label: "documents",
    icon: <FileTextOutlined />,
    to: COMPANY_DOCUMENTS_PATH,
  },
];
